<template>
  <!-- BEGIN: Top Bar -->
  <div class="top-bar">
    <!-- BEGIN: Breadcrumb -->
    <div class="hidden mr-auto -intro-x breadcrumb sm:flex">
      <span class="intro-x text-color-highlight">Application</span>
      <ChevronRightIcon class="intro-x breadcrumb__icon text-color-highlight" />
      <span class="intro-x breadcrumb--active">{{ page?.meta?.text ?? page?.name }}</span>
    </div>
    <!-- END: Breadcrumb -->
    <!-- BEGIN: Notifications -->
    <div class="hidden mr-auto intro-x dropdown sm:mr-6">
      <div class="cursor-pointer dropdown-toggle notification notification--bullet" role="button" aria-expanded="false">
        <BellIcon class="notification__icon dark:text-gray-300" />
      </div>
      <div class="pt-2 notification-content dropdown-menu">
        <div class="notification-content__box dropdown-menu__content box dark:bg-dark-6">
          <div class="notification-content__title">Notifications</div>
          <div v-for="(faker, fakerKey) in $_.take($f(), 5)" :key="fakerKey"
            class="relative flex items-center cursor-pointer" :class="{ 'mt-5': fakerKey }">
            <div class="flex-none w-12 h-12 mr-1 image-fit">
              <img alt="Icewall Tailwind HTML Admin Template" class="rounded-full"
                :src="require(`@/assets/images/${faker.photos[0]}`)" />
              <div class="absolute bottom-0 right-0 w-3 h-3 border-2 border-white rounded-full bg-theme-9"></div>
            </div>
            <div class="ml-2 overflow-hidden">
              <div class="flex items-center">
                <a href="javascript:;" class="mr-5 font-medium truncate">{{
                  faker.users[0].name
                }}</a>
                <div class="ml-auto text-xs text-gray-500 whitespace-nowrap">
                  {{ faker.times[0] }}
                </div>
              </div>
              <div class="w-full truncate text-gray-600 mt-0.5">
                {{ faker.news[0].shortContent }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Notifications -->
    <!-- BEGIN: package -->
    <div class="flex mr-2 intro-x dropdown sm:mr-2" v-if="hasPackage  && userPackage.isFreeTrial">
      <div class="flex cursor-pointer dropdown-toggle" role="button" aria-expanded="false">
        <router-link to="/profile" style="cursor:pointer"
          class="flex items-center p-2 text-blue-400 transition duration-300 ease-in-out rounded-md hover:bg-theme-1 dark:hover:bg-dark-3">
          <img :src="imgFreeTrial" class="w-5 h-5 mr-2" />
          <span style="color:#718096">
            Free Trial
          </span>
        </router-link>
      </div>
    </div>
    <div class="flex mr-2 intro-x dropdown sm:mr-2" v-if="packageData.isShow">
      <div class="flex cursor-pointer dropdown-toggle" role="button" aria-expanded="false">
        <router-link to="/profile" style="cursor:pointer"
          class="flex items-center p-2 text-blue-400 transition duration-300 ease-in-out rounded-md hover:bg-theme-1 dark:hover:bg-dark-3">
          <img :src="packageData.image" class="w-5 h-5 mr-2" />
          <span :style="`color:${packageData.fontColor}`">
            {{ packageData.message }}
          </span>
        </router-link>
      </div>
    </div>
    <!-- END: package -->
    <!-- BEGIN: youtube -->
    <div class="pr-4 mr-4 intro-x dropdown sm:mr-6" style="border-right: 1px solid !important;">
      <div class="cursor-pointer dropdown-toggle" role="button" aria-expanded="false">
        <a href="https://www.youtube.com/watch?v=gl5siVp35AU" target="_blank" style="cursor:pointer"
          class="flex items-center p-2 text-blue-400 transition duration-300 ease-in-out rounded-md hover:bg-theme-1 dark:hover:bg-dark-3">
          <img class="w-6 h-6 mr-3 intro-x" :src="imgYoutube" />
          <label class="intro-x" style="cursor:pointer;text-decoration: underline;"> วิธีการใช้งาน StatementPro</label>
        </a>
      </div>
    </div>
    <!-- END: youtube -->
    <!-- BEGIN: Account Menu -->
    <div class="w-8 h-8 intro-x dropdown" id="accountToggle">
      <div class="w-8 h-8 overflow-hidden rounded-full shadow-lg dropdown-toggle image-fit zoom-in" role="button"
        aria-expanded="false">
        <img alt="Icewall Tailwind HTML Admin Template" :src="$helpers.isNull(imageProfile) ? imgLogo : imageProfile" />
      </div>
      <div class="w-56 dropdown-menu">
        <div class="text-white dropdown-menu__content box bg-color-ddl">
          <div class="p-4 border-color">
            <div class="font-medium">{{ userProfile?.firstName + ' ' + userProfile?.lastName }}</div>
          </div>
          <div v-if="isSyncProvider === true" class="p-2 border-color">
            <a href="#" @click.prevent="onBackProviderClicked"
              class="flex items-center block p-2 transition duration-300 ease-in-out rounded-md hover:bg-theme-1 dark:hover:bg-dark-3">
              <ChevronLeftIcon class="w-4 h-4 mr-2" /> Back To {{ userProvider?.name }}
            </a>
          </div>
          <div class="p-2">
            <a href="#" @click.prevent="onProfileClicked"
              class="flex items-center block p-2 transition duration-300 ease-in-out rounded-md hover:bg-theme-1 dark:hover:bg-dark-3">
              <UserIcon class="w-4 h-4 mr-2" /> Manage Profile
              <Tippy v-if="userProfile?.isEmailVerified === false" class="ml-2 -mt-1 text-yellow-400 tooltip"
                content="Email has not been verified.">
                <AlertCircleIcon class="w-4 h-4" />
              </Tippy>
            </a>
          </div>
          <div class="p-2 border-t border-color">
            <a href="#" @click.prevent="handleLogout"
              class="flex items-center block p-2 transition duration-300 ease-in-out rounded-md hover:bg-theme-1 dark:hover:bg-dark-3">
              <ToggleRightIcon class="w-4 h-4 mr-2" /> Logout
            </a>
          </div>
          <div class="p-4 border-t border-color" style="display: none;">
            <div class="font-medium">
              <DarkModeSwitcher :isAttach="true" />
            </div>
            <div class="text-xs text-theme-28 -mt-7 dark:text-gray-600">
              Theme mode
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Account Menu -->
  </div>
  <!-- END: Top Bar -->
</template>

<script>
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import DarkModeSwitcher from '@/components/dark-mode-switcher/Main.vue'
import { mapGetters } from 'vuex'
import imgYoutube from '@/assets/images/Youtube32.png'
import imgLogo from '@/assets/images/Logo Dashboard.png'
import imgNoPackage from '@/assets/images/NoPackage64.png'
import imgFreeTrial from '@/assets/images/FreeTrial64.png'
import { useStore } from '@/store'
import * as getterTypes from '@/store/getter-types'
import * as actionTypes from '@/store/action-types'

export default defineComponent({
  computed: {
    ...mapGetters({
      page: `main/${getterTypes.GET_PAGE}`,
      isSyncProvider: `main/${getterTypes.GET_IS_SYNC_PROVIDER}`,
      userProvider: `main/${getterTypes.GET_PROVIDER}`,
      userPackage: `main/${getterTypes.GET_PACKAGE}`,
      hasPackage: `main/${getterTypes.GET_HAS_PACKAGE}`,
      imageProfile: `main/${getterTypes.GET_IMAGE}`,
      userProfile: `main/${getterTypes.GET_PROFILE}`
    }),
    packageData() {
      let isExpiryDate = null
      let isShow = null
      let image = null
      let fontColor = null
      let message = null
      if (this.hasPackage) {
        const now = this.$filters.formatDateOut(new Date())
        const expiryDate = new Date(this.userPackage.expiryDate)
        isExpiryDate = now > expiryDate
        if (isExpiryDate) {
          isShow = true
          image = this.imgNoPackage
          fontColor = '#CD6155'
          message = 'Package หมดอายุ'
        }
      } else {
        isShow = true
        image = this.imgNoPackage
        fontColor = '#F9E679'
        message = 'ไม่มี Package'
      }
      return {
        isShow,
        isExpiryDate,
        image,
        fontColor,
        message
      }
    }
  },
  components: { DarkModeSwitcher },
  data() {
    return {
      imgFreeTrial,
      imgNoPackage,
      imgLogo,
      imgYoutube,
      priceList: [],
      currentCurrency: false
    }
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const searchDropdown = ref(false)

    const showSearchDropdown = () => {
      searchDropdown.value = true
    }

    const hideSearchDropdown = () => {
      searchDropdown.value = false
    }

    const delay = async (milliseconds) => {
      return new Promise(resolve => {
        setTimeout(resolve, milliseconds)
      })
    }

    const handleLogout = async () => {
      document.getElementById('accountToggle').click()
      await delay(1000)
      store.dispatch(`main/${actionTypes.CLEAR_DATA}`)
      router.push({
        name: 'login'
      })
    }

    const handleProfile = () => {
      document.getElementById('accountToggle').click()
      router.push({
        name: 'profile'
      })
    }

    return {
      searchDropdown,
      showSearchDropdown,
      hideSearchDropdown,
      handleProfile,
      handleLogout,
      store,
      onProfileClicked: handleProfile
    }
  },
  methods: {
    async onBackProviderClicked() {
      if (!this.$helpers.isNull(this.userProvider.tokenJson)) {
        const temp = JSON.parse(this.userProvider.tokenJson)
        const redirectURL = `${window.__env.api.peakURL}LightworkDetail?PeakToken=${temp.Peakurl}&PeakUserID=${temp.PeakUserId}&LWToken=${this.userProfile?.key}`
        window.location = redirectURL
      }
    }
  }
})
</script>
